import { createRequest } from "../../helpers/requests";

const mailingListsUrl = "/mailing_lists";

export const createMailingList = (email, onSuccess = () => {}, onFailure = () => {}, recaptchaToken = null) => {
  const requestData = {
    email,
    ...(recaptchaToken && { "g-recaptcha-response": recaptchaToken }),
  };

  return createRequest(mailingListsUrl, requestData, (response) => {
    const data = response.data;

    if (data && data.success === true) {
      onSuccess();

      // Disable redirect for mailing list creation
      // if (data.redirect_url) {
      //   window.location.href = data.redirect_url;
      // }
    } else {
      console.error("Mailing list creation failed", data?.message || "Unknown error");
      onFailure(data || { success: false, message: data?.message || "Unknown error" });
    }
  }, (error) => {
    console.error("Mailing list creation failed", error);
    onFailure(error);
  });
};